import { useEffect } from 'react'
import BottomSheetContent from '../BottomSheetContent'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { toPascalCaseWithSpaces } from '../../../utils/utils'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
  fundCategory: string
  fundOrientation: 'equity-oriented' | 'debt-oriented' | 'non-equity'
}

export const IndicativeTax = ({
  onDismiss,
  ScreenName,
  fundCategory,
  fundOrientation
}: BottomSheetWrapperPropTypes) => {
  const heading = 'Why is this fund’s tax indicative?'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} onDismiss={onDismiss}>
      <div className='text-[#6A6E6E] leading-[150%] text-[14px] font-[400]'>
        Unlike other categories that have defined allocation rules (like, investing min. 60% in equity),{' '}
        {toPascalCaseWithSpaces(fundCategory)} Funds{' '}
        <span className='text-[#3D3D3D]'>
          don&apos;t have such defined rules. They can adjust their allocation flexibly.{' '}
        </span>{' '}
        <br /> <br /> Tax treatment depends on the fund&apos;s average allocation during the year. If it has:
        <ul className='list-disc list-inside pl-2'>
          <li>
            {' '}
            <span className='-ml-[2px]'>65% or more in equity: taxed as equity-oriented</span>
          </li>
          <li>
            {' '}
            <span className='-ml-[2px]'>65% or more in debt: taxed as debt-oriented</span>
          </li>
          <li>
            {' '}
            <span className='-ml-[2px]'>Other cases: non-equity taxation rules apply</span>
          </li>
        </ul>
        <br />
        Based on historical allocation data, this fund is likely to be taxed as{' '}
        <span className='font-[700]'> {fundOrientation} </span> fund.
      </div>
    </BottomSheetContent>
  )
}
